import styled, { css } from 'styled-components';
import { commonStyle } from '../../utils/commonStyle';
import { space } from '../../utils/space';
import { textDecoration } from '../../utils/textDecoration';
import { whiteSpace } from '../../utils/whiteSpace';
export const typographyVariantStyles = {
    largeTitle: css `
    font-family: 'Swile', sans-serif;
    font-size: 32px;
    font-weight: 700;
    line-height: 40px;
    letter-spacing: 0;
  `,
    h1: css `
    font-family: 'Swile', sans-serif;
    font-size: 28px;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: 0;
  `,
    h2: css `
    font-family: 'Swile', sans-serif;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
  `,
    h3: css `
    font-family: 'Swile', sans-serif;
    font-size: 22px;
    font-weight: 700;
    line-height: 32px;
  `,
    headline: css `
    font-family: 'Swile', sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
  `,
    hugeBody: css `
    font-family: 'Graphik', sans-serif;
    font-size: 32px;
    line-height: 40px;
  `,
    body: css `
    font-family: 'Graphik', sans-serif;
    font-size: 16px;
    line-height: 24px;
  `,
    callout: css `
    font-family: 'Graphik', sans-serif;
    font-size: 14px;
    line-height: 20px;
  `,
    footnote: css `
    font-family: 'Graphik', sans-serif;
    font-size: 13px;
    line-height: 16px;
  `,
    caption: css `
    font-family: 'Graphik', sans-serif;
    font-size: 12px;
    line-height: 16px;
  `,
    label: css `
    font-family: 'Graphik', sans-serif;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 1px;
    text-transform: uppercase;
  `,
};
const typographyWeightStyles = {
    strong: css `
    font-weight: 600;
  `,
    medium: css `
    font-weight: 500;
  `,
    normal: css `
    font-weight: 400;
  `,
};
export const StyledTypography = styled.div `
  ${commonStyle};

  color: ${({ color, theme }) => color || theme.colors.content.default};
  margin: 0;
  text-align: ${(props) => props.align || 'inherit'};
  display: ${(props) => props.display || 'inherit'};

  ${({ weight }) => weight && typographyWeightStyles[weight]}
  ${({ variant }) => typographyVariantStyles[variant]}

  ${({ as, color, theme }) => as === 'a' &&
    `
    color: ${color || theme.colors.content.primary};
    text-decoration: none;
    transition: 200ms ease-in-out;
    &:hover {
      color: ${theme.colors.content.default};
    }
  `};
  ${({ as, color, theme }) => as === 'button' &&
    `
    color: ${color || theme.colors.content.primary};
    background: none;
    border: none;
    padding: 0px;
    transition: 200ms ease-in-out;
    &:hover {
      color: ${theme.colors.content.default};
      cursor: pointer;
    }
  `};
  ${textDecoration}
  ${space}
  ${whiteSpace}
`;
